export const buildCountryMap = (countries = []) => {
  return countries.reduce((acc, c) => {
    acc[c.code] = c.name
    return acc
  }, {})
}
